import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { supportedDateFormats } from '../isDate'

dayjs.extend(utc)
dayjs.extend(customParseFormat)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)

const formatDate = (date) => {
  if (!date) return null
  return dayjs(date, supportedDateFormats).format('LL')
}

export { formatDate }
